import React from 'react';
import { ArrowRight, Lock } from 'lucide-react';
import { BakeryEvent } from '../types/event';
interface EventRowProps {
  event: BakeryEvent;
  onSignup: (event: BakeryEvent) => void;
}
export function EventRow({
  event,
  onSignup
}: EventRowProps) {
  const date = new Date(`${event.date}T12:00:00`);
  const weekday = date.toLocaleDateString('sv-SE', {
    weekday: 'long'
  });
  const shortDate = `${date.getDate()}/${date.getMonth() + 1}`;
  if (event.locked) {
    return <article className="relative overflow-hidden rounded-2xl bg-[#1C1917]" aria-label={event.lockedText ?? 'Kommer snart'} data-id="element-452" data-mp="1krw5f6bap34t">
        <div aria-hidden="true" inert className="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-x-6 gap-y-3 p-5 md:p-6 blur-[6px] opacity-50 select-none pointer-events-none" data-id="element-453" data-mp="1frhu9feedd2k">
          <div className="flex sm:flex-col items-baseline sm:items-start sm:justify-center gap-2 sm:gap-0" data-id="element-454" data-mp="4f7a1xdpyp9q">
            <span className="text-sm text-[#F5EDE3]/60 capitalize" data-id="element-455" data-mp="3vim7ppo44958">
              {weekday}
            </span>
            <span className="text-3xl md:text-4xl font-extrabold text-[#FFB27A] leading-none tracking-tight" data-id="element-456" data-mp="1uj8a9xnvsgr1">
              {shortDate}
            </span>
          </div>
          <div className="min-w-0" data-id="element-457" data-mp="1kmln32831dlu">
            {/* Placeholder shapes only – the real event stays secret */}
            <div className="h-7 w-48 rounded-md bg-[#F5EDE3]/70 mb-3" data-id="element-458" data-mp="1pkdelv4texpi" />
            <div className="space-y-2" data-id="element-459" data-mp="1bts3wtpilu2p">
              <div className="h-3.5 w-full rounded bg-[#F5EDE3]/40" data-id="element-460" data-mp="1bsqhxu6ynn67" />
              <div className="h-3.5 w-11/12 rounded bg-[#F5EDE3]/40" data-id="element-461" data-mp="1gmbf5k0qcd4c" />
              <div className="h-3.5 w-2/3 rounded bg-[#F5EDE3]/40" data-id="element-462" data-mp="11xf0h44641ur" />
            </div>
            <div className="mt-5 flex sm:justify-end" data-id="element-463" data-mp="16vgtagrebfjf">
              <span className="h-10 w-32 rounded-full bg-[#FF7A1A]" data-id="element-464" data-mp="16w00b2ficjio" />
            </div>
          </div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center bg-[#0E0C0B]/40" data-id="element-465" data-mp="sybglxx6fif7">
          <span className="w-11 h-11 rounded-full bg-[#0E0C0B] border border-[#FF7A1A]/60 flex items-center justify-center" data-id="element-466" data-mp="2zjy1vo6d58v6">
            <Lock className="w-5 h-5 text-[#FF9A4D]" aria-hidden="true" data-id="element-467" data-mp="2usga9qq8ckmv" />
          </span>
          <p className="halloween-display text-2xl md:text-3xl text-[#FF9A4D] tracking-wide leading-tight" data-id="element-468" data-mp="2ptmx5zeuuvn8">
            {event.lockedText ?? 'Kommer snart'}
          </p>
        </div>
      </article>;
  }
  return <article className="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-x-6 gap-y-3 bg-[#1C1917] rounded-2xl p-5 md:p-6" data-id="element-469" data-mp="3ihr4sqgzlisk">
      <div className="flex sm:flex-col items-baseline sm:items-start sm:justify-center gap-2 sm:gap-0" data-id="element-470" data-mp="3dks8c19uozr7">
        <span className="text-sm text-[#F5EDE3]/60 capitalize" data-id="element-471" data-mp="38mz6tljhstx9">{weekday}</span>
        <span className="text-3xl md:text-4xl font-extrabold text-[#FFB27A] leading-none tracking-tight" data-id="element-472" data-mp="34irdtc604rt8">
          {shortDate}
        </span>
      </div>

      <div className="min-w-0" data-id="element-473" data-mp="1t4dxqthhpgnr">
        <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 mb-2" data-id="element-474" data-mp="1t3cjkg56ge1t">
          <h3 className="text-xl md:text-2xl font-bold text-[#F5EDE3] leading-tight" data-id="element-475" data-mp="8n4miwhprwzk">
            {event.title}
          </h3>
          {(event.time || event.secondaryTime) && <div className="flex flex-wrap gap-2 shrink-0" data-id="element-476" data-mp="hm9l22t9zqbq">
              {event.time && <span className="px-3 py-1 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold whitespace-nowrap" data-id="element-477" data-mp="me1ecl3tga5k">
                  {event.time}
                </span>}
              {event.secondaryTime && <span className="px-3 py-1 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-478" data-mp="wacrtef5761l">
                  {event.secondaryTime}
                </span>}
            </div>}
        </div>

        <p className="text-[#F5EDE3]/80 leading-relaxed" data-id="element-479" data-mp="324npbh09zvrv">{event.description}</p>

        {event.highlight && <p className="mt-4 rounded-xl bg-[#2A1D14] px-4 py-3 text-[#F5EDE3]/85 leading-relaxed" data-id="element-480" data-mp="3737858jkorg0">
            <span className="font-bold text-[#FF9A4D]" data-id="element-481" data-mp="2bt0zdu3qu7q9">
              {event.highlight.title}
            </span>{' '}
            – {event.highlight.text}
          </p>}

        {event.dropIn && !event.signup && <div className="mt-5 flex sm:justify-end" data-id="element-482" data-mp="2lqosygpm596u">
            <span className="inline-flex items-center px-5 py-2.5 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-483" data-mp="2gsncm3jknnz2">
              Drop in
            </span>
          </div>}

        {event.signup && <div className="mt-5 flex sm:justify-end" data-id="element-484" data-mp="1o5aohoxrj83n">
            <button onClick={() => onSignup(event)} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold hover:bg-[#FF9A4D] transition-colors whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFB27A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1C1917]" data-id="element-485" data-mp="22sm1lv9lf05v">
              {event.ctaLabel ?? 'Boka plats'}
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-486" data-mp="3h01zbygsy9dx" />
            </button>
          </div>}

        {event.footnote && <p className="mt-5 pt-4 border-t border-[#F5EDE3]/10 text-sm text-[#F5EDE3]/60 leading-relaxed" data-id="element-487" data-mp="372nt0rolf0zc">
            {event.footnote}
          </p>}
      </div>
    </article>;
}